import React, { Component } from "react";

import { Snackbar, Drawer } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import CookieHandler from "../../common/CookieHandler";
import config from "../../../config/config";
import api from "../../../api/api";

import MvBuyerDemurrageAdd from "./Mv_Buyer_DemurrageAdd";
import MvBuyerDemurrageView from "./Mv_Buyer_DemurrageView";
import MvBuyerDemurrageUpdate from "./Mv_Buyer_DemurrageUpdate";
import Loader from "../../common/Loader";
import { toLocaleString } from "../../common/common";

export default class MvBuyerDemurrageList extends Component {
  constructor(props) {
    super();
    this.Cookie = new CookieHandler();
    this.state = {
      buyerData: [
        {
          buyer: "0",
          demurrage_per_day: "",
          billing_currency: "0",
          despatch_per_day: "",
          despatch_currency: "0",
          demurrage_or_despatch: "Demurrage",
          demurrage_in_days: "",
          demurrage_incurred: "",
          despatch_in_days: "",
          despatch_incurred: "",
        },
      ],
      buyer_menu: [],
      isLoading: true,
      updateDocuments: false,
    };
  }

  async componentDidMount() {
    if (!this.Cookie.isLoggedIn()) {
      this.props.history.replace("/logout");
    }
    const features = this.Cookie.getCookie("features");
    this.setState({ features: features });
    if (!(features.includes("50") || features.includes("97"))) {
      window.location.href = "/dashboard";
    }
    const loginUserID = this.Cookie.getCookie("loginUserId");
    const idToken = this.Cookie.getIdTokenCookie();
    const businessNoID = this.props.businessNoID;

    await api
      .get_mv_buyer_demurrage(loginUserID, idToken, businessNoID)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              if (res.mv_buyer_demurrage) {
                for (var i in res.mv_buyer_demurrage) {
                  var total_paid_amout = 0;
                  for (var j of res.mv_buyer_demurrage[i]
                    .buyer_demurrage_payments) {
                    total_paid_amout += Number(j.amount);
                  }
                  res.mv_buyer_demurrage[i].total_paid_amout = total_paid_amout;
                  res.mv_buyer_demurrage[i].remaining_amount =
                    Number(
                      res.mv_buyer_demurrage[i].buyer_total
                        ? res.mv_buyer_demurrage[i].buyer_total
                        : 0
                    ) - Number(total_paid_amout);
                }
                this.setState({
                  buyerData: res.mv_buyer_demurrage,
                  isLoading: false,
                });

                if (res.mv_buyer_demurrage.length === 0) {
                  this.setState({
                    errorMsg: "No Buyer Demurrage Data Available.",
                  });
                  window.$("#AlertMessageModal").modal({
                    backdrop: "static",
                    keyboard: true,
                    show: true,
                  });
                }
              } else {
                alert(
                  "Unexpected error occured. Please contact administrator."
                );
              }
            } else if (res.code === "601") {
              this.setState({
                errorMsg: res.message,
                successMsg: "",
                isLoading: false,
              });
            } else if (res.code === "607") {
              window.location.href = "/logout";
            }
          });
        }
      });
  }

  onAddResponse = (value) => {
    if (value.code === "200") {
      this.setState(
        {
          MvBuyerDemurrageAdd: false,
          MvBuyerDemurrageView: false,
          MvBuyerDemurrageUpdate: false,
          openDrawer: false,
          updateDocuments: false,
        },
        () => this.componentDidMount()
      );
    } else {
      this.setState({
        MvBuyerDemurrageAdd: false,
        MvBuyerDemurrageView:
          value.screen === "MvBuyerDemurrage" &&
            value.message === "alreadyDataAvailable"
            ? true
            : false,
        MvBuyerDemurrageUpdate: false,
        openDrawer: true,
        updateDocuments: false,
      });
    }
  };

  CallbackDrawerClose = (childData) => {
    this.setState(
      {
        openDrawer: childData,
        MvBuyerDemurrageAdd: false,
        MvBuyerDemurrageView: false,
        MvBuyerDemurrageUpdate: false,
        updateDocuments: false,
      },
      () => this.componentDidMount()
    );
  };

  onUpdateResponse = (value) => {
    if (value) {
      this.setState(
        {
          MvBuyerDemurrageAdd: false,
          MvBuyerDemurrageView:
            value.code === "200" && value.screen === "MvBuyerDemurrage"
              ? true
              : false,
          MvBuyerDemurrageUpdate: false,
          updateDocuments: false,
        },
        () => this.componentDidMount()
      );
    }
  };

  CallbackViewPage = (childData) => {
    this.setState(
      {
        openDrawer: true,
        MvBuyerDemurrageUpdate: false,
        MvBuyerDemurrageAdd: false,
        MvBuyerDemurrageView: childData === "MvBuyerDemurrage" ? true : false,
        updateDocuments: false,
      },
      () => this.componentDidMount()
    );
  };

  editCallback = (childData) => {
    this.setState(
      {
        openDrawer: true,
        MvBuyerDemurrageUpdate: childData === "MvBuyerDemurrage" ? true : false,
        MvBuyerDemurrageAdd: false,
        MvBuyerDemurrageView: false,
        updateDocuments: false,
      },
      () => this.componentDidMount()
    );
  };

  deleteCharges = (data) => {
    var loginUserID = this.Cookie.getCookie("loginUserId");
    var idToken = this.Cookie.getIdTokenCookie();
    var finalData = data;
    finalData.buyer_demurrage_id = data.id;
    finalData.login_user_id = loginUserID;
    finalData.idtoken = idToken;
    finalData.status = "Deleted";
    // return;
    //Update
    api.update_mv_pur_fin_buyer_demurrage(finalData).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if (res.code === "200") {
            this.setState(
              {
                snackBarSuccessOpen: true,
                successMsg: res.message,
              },
              () => this.componentDidMount()
            );
          } else if (res.code === "601") {
            this.setState({ errorMsg: res.message, snackBarErrorOpen: true });
          } else if (res.code === "607") {
            window.location.href = "/logout";
          } else if (res.code === "624") {
            this.setState({
              errorMsg: res.columns.length > 0 ? res.columns[0] : "",
              snackBarErrorOpen: true,
            });
          }
        });
      }
    });
  };

  render() {
    let drawerComponent;
    if (this.state.MvBuyerDemurrageAdd) {
      drawerComponent = (
        <MvBuyerDemurrageAdd
          businessNoID={this.props.businessNoID}
          onAddResponse={this.onAddResponse}
          returnCallbackDrawerClose={this.CallbackDrawerClose}
        />
      );
    } else if (this.state.MvBuyerDemurrageView && this.state.businessNo) {
      drawerComponent = (
        <MvBuyerDemurrageView
          MvBuyerDemurrageID={this.state.MvBuyerDemurrageID}
          businessNoID={this.state.businessNo}
          returnCallbackDrawerClose={this.CallbackDrawerClose}
          returnEditCallback={this.editCallback}
          returnDocumentsHandler={() => {
            this.setState({
              showDrawer: true,
              MvBuyerDemurrageUpdate: true,
              MvBuyerDemurrageView: false,
              MvBuyerDemurrageAdd: false,
              updateDocuments: true,
            });
          }}
        />
      );
    } else if (this.state.MvBuyerDemurrageUpdate && this.state.businessNo) {
      drawerComponent = (
        <MvBuyerDemurrageUpdate
          MvBuyerDemurrageID={this.state.MvBuyerDemurrageID}
          businessNoID={this.state.businessNo}
          onUpdateCosting={this.onUpdateResponse}
          returnCallbackViewPage={this.CallbackViewPage}
          updateDocuments={this.state.updateDocuments}
        />
      );
    }
    if (this.state.isLoading) {
      return <Loader />;
    } else {
      return (
        <div>
          <div className="row clearfix content-header border-bottom">
            <div className="row clearfix content-header border-bottom">
              <h4 className="mt-2" style={{ padding: "4px" }}>
                {`Buyer Demurrage - ${this.props.mother_vessel_name
                    ? this.props.mother_vessel_name
                    : ""
                  } ${this.props.name ? `( ${this.props.name} )` : ""}`}
              </h4>
              {(this.state.features.includes("49") ||
                this.state.features.includes("97")) && (
                  <i
                    className="fa fa-plus-circle ml-2 mt-3"
                    aria-hidden="true"
                    style={{
                      fontSize: 22,
                      color: config.themeColor,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      this.setState({
                        openDrawer: true,
                        MvBuyerDemurrageAdd: true,
                        MvBuyerDemurrageView: false,
                        MvBuyerDemurrageUpdate: false,
                      });
                    }}
                  />
                )}
            </div>
          </div>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={this.state.snackBarErrorOpen}
            onClose={() => this.setState({ snackBarErrorOpen: false })}
            style={{ width: "450px" }}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarErrorOpen: false })}
              severity="error"
              style={{ width: "100%" }}
            >
              {this.state.errorMsg}
            </Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            style={{ width: "450px" }}
            open={this.state.snackBarSuccessOpen}
            autoHideDuration={100000}
            onClose={() => this.setState({ snackBarSuccessOpen: false })}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarSuccessOpen: false })}
              severity="success"
              style={{ width: "100%" }}
            >
              {this.state.successMsg}
            </Alert>
          </Snackbar>
          <Drawer
            anchor="right"
            open={this.state.openDrawer}
            variant="temporary"
            elevation={20}
            style={{ overflow: "initial" }}
          >
            <div className="row" style={{ width: 800 }}>
              {drawerComponent}
            </div>
          </Drawer>
          <div className="card pl-0 pr-0">
            <div
              className="card-body p-0"
              style={{ backgroundColor: "rgba(25,118,210,.01)" }}
              id="accordion"
            >
              <div className="col-lg-12 mb-2 p-0">
                <div className="row">
                  <div className="table-responsive">
                    <table className="table table-sm table-bordered">
                      <thead className="table-header">
                        <tr>
                          <th nowrap="true">Costing ID</th>
                          <th nowrap="true">Buyer</th>
                          <th nowrap="true" className="text-right">
                            Buyer Demurrage Per Day
                          </th>
                          <th nowrap="true" className="text-right">
                            Despatch
                          </th>
                          <th nowrap="true"> Type </th>
                          <th nowrap="true" className="text-right">
                            Demurrage/Despatch Incurred
                          </th>
                          <th nowrap="true" className="text-right">
                            Cost to Company
                          </th>
                          <th nowrap="true" className="text-left pl-4">
                            Action
                          </th>
                        </tr>
                      </thead>
                      {
                        this.props.demurrageType === "Despatch" &&
                        this.state.buyerData.length > 0 && (
                          <tbody>
                            {this.state.buyerData
                              .filter(
                                (e) => e.demurrage_or_despatch === "Despatch"
                              )
                              .map((idr, indx) => (
                                <tr key={indx}>
                                  {this.state.features.includes("50") ||
                                    this.state.features.includes("97") ? (
                                    <td>
                                      <i
                                        aria-hidden="true"
                                        style={{
                                          fontStyle: "normal",
                                          color: config.themeColor,
                                          cursor: "pointer",
                                          whiteSpace: "nowrap",
                                        }}
                                        onClick={() =>
                                          this.setState({
                                            openDrawer: true,
                                            MvBuyerDemurrageAdd: false,
                                            MvBuyerDemurrageView: true,
                                            MvBuyerDemurrageUpdate: false,
                                            businessNo: idr.business_no_id,
                                            MvBuyerDemurrageID: idr.id,
                                          })
                                        }
                                      >
                                        {idr.costing_no}
                                      </i>
                                    </td>
                                  ) : (
                                    <td nowrap="true">{idr.costing_no}</td>
                                  )}
                                  <td nowrap="true">{idr.buyer_name}</td>
                                  <td
                                    className="allocation_table_value text-right"
                                    nowrap="true"
                                  >
                                    {toLocaleString(idr.demurrage_per_day)}
                                    {idr.billing_currency}
                                  </td>
                                  <td
                                    className="allocation_table_value text-right"
                                    nowrap="true"
                                  >
                                    {toLocaleString(idr.despatch_per_day)}
                                  </td>
                                  <td nowrap="true">
                                    {idr.demurrage_or_despatch}
                                  </td>
                                  {idr.demurrage_or_despatch ===
                                    "Demurrage" ? (
                                    <td
                                      className="allocation_table_value text-right"
                                      nowrap="true"
                                    >
                                      {toLocaleString(idr.demurrage_incurred)}
                                    </td>
                                  ) : (
                                    <td
                                      className="allocation_table_value text-right"
                                      nowrap="true"
                                    >
                                      {toLocaleString(idr.despatch_incurred)}
                                    </td>
                                  )}
                                  <td
                                    className="allocation_table_value text-right"
                                    nowrap="true"
                                  >
                                    {toLocaleString(idr.buyer_ctc)}
                                    {config.company === "SRPL" ||
                                      config.company === "AVS" ||
                                      config.company === "PRPL"
                                      ? "USD"
                                      : "IDR"}
                                  </td>
                                  <td
                                    nowrap="true"
                                    className="table_td text-left pl-4"
                                  >
                                    {(this.state.features.includes("51") ||
                                      this.state.features.includes("97")) && (
                                        <i
                                          className="fa fa-pencil"
                                          style={{
                                            fontSize: 14,
                                            color: config.themeColor,
                                            cursor: "pointer",
                                          }}
                                          data-toggle="modal"
                                          title="Edit floating crane charges"
                                          data-placement="bottom"
                                          onClick={() =>
                                            this.setState({
                                              businessNo: idr.business_no_id,
                                              MvBuyerDemurrageID: idr.id,
                                              openDrawer: true,
                                              MvBuyerDemurrageUpdate: true,
                                            })
                                          }
                                        ></i>
                                      )}
                                    {idr.payment_postings_availability ===
                                      0 &&
                                      (this.state.features.includes("388") ||
                                        this.state.features.includes(
                                          "97"
                                        )) && (
                                        <i
                                          className="fa fa-trash-o"
                                          style={{
                                            paddingLeft: 10,
                                            fontSize: 14,
                                            color: config.themeColor,
                                            cursor: "pointer",
                                          }}
                                          data-toggle="modal"
                                          title="Delete floating crane charges"
                                          data-placement="bottom"
                                          data-keyboard="false"
                                          data-target="#deleteConformationModal"
                                          data-backdrop="static"
                                          onClick={() =>
                                            this.deleteCharges(idr)
                                          }
                                        ></i>
                                      )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        )
                        // : (
                        //   <tbody>
                        //     <tr>
                        //       <td colSpan="7" className="p-2">
                        //         No data available
                        //       </td>
                        //     </tr>{" "}
                        //   </tbody>
                        // )
                      }
                      {this.props.demurrageType === "Demurrage" &&
                        this.state.buyerData.length > 0 && (
                          <tbody>
                            {this.state.buyerData
                              .filter(
                                (e) => e.demurrage_or_despatch === "Demurrage"
                              )
                              .map((idr, indx) => (
                                <tr key={indx}>
                                  {this.state.features.includes("50") ||
                                    this.state.features.includes("97") ? (
                                    <td>
                                      <i
                                        aria-hidden="true"
                                        style={{
                                          fontStyle: "normal",
                                          color: config.themeColor,
                                          cursor: "pointer",
                                          whiteSpace: "nowrap",
                                        }}
                                        onClick={() =>
                                          this.setState({
                                            openDrawer: true,
                                            MvBuyerDemurrageAdd: false,
                                            MvBuyerDemurrageView: true,
                                            MvBuyerDemurrageUpdate: false,
                                            businessNo: idr.business_no_id,
                                            MvBuyerDemurrageID: idr.id,
                                          })
                                        }
                                      >
                                        {idr.costing_no}
                                      </i>
                                    </td>
                                  ) : (
                                    <td nowrap="true">{idr.costing_no}</td>
                                  )}
                                  <td nowrap="true">{idr.buyer_name}</td>
                                  <td
                                    className="allocation_table_value text-right"
                                    nowrap="true"
                                  >
                                    {toLocaleString(idr.demurrage_per_day)}
                                    {idr.billing_currency}
                                  </td>
                                  <td
                                    className="allocation_table_value text-right"
                                    nowrap="true"
                                  >
                                    {toLocaleString(idr.despatch_per_day)}
                                  </td>
                                  <td nowrap="true">
                                    {idr.demurrage_or_despatch}
                                  </td>
                                  {idr.demurrage_or_despatch === "Demurrage" ? (
                                    <td
                                      className="allocation_table_value text-right"
                                      nowrap="true"
                                    >
                                      {toLocaleString(idr.demurrage_incurred)}
                                    </td>
                                  ) : (
                                    <td
                                      className="allocation_table_value text-right"
                                      nowrap="true"
                                    >
                                      {toLocaleString(idr.despatch_incurred)}
                                    </td>
                                  )}
                                  <td
                                    className="allocation_table_value text-right"
                                    nowrap="true"
                                  >
                                    {toLocaleString(idr.buyer_ctc)}
                                    {config.company === "SRPL" ||
                                      config.company === "AVS" ||
                                      config.company === "PRPL"
                                      ? "USD"
                                      : "IDR"}
                                  </td>
                                  <td
                                    nowrap="true"
                                    className="table_td text-left pl-4"
                                  >
                                    {(this.state.features.includes("51") ||
                                      this.state.features.includes("97")) && (
                                        <i
                                          className="fa fa-pencil"
                                          style={{
                                            fontSize: 14,
                                            color: config.themeColor,
                                            cursor: "pointer",
                                          }}
                                          data-toggle="modal"
                                          title="Edit floating crane charges"
                                          data-placement="bottom"
                                          onClick={() =>
                                            this.setState({
                                              businessNo: idr.business_no_id,
                                              MvBuyerDemurrageID: idr.id,
                                              openDrawer: true,
                                              MvBuyerDemurrageUpdate: true,
                                            })
                                          }
                                        ></i>
                                      )}
                                    {idr.payment_postings_availability === 0 &&
                                      (this.state.features.includes("388") ||
                                        this.state.features.includes("97")) && (
                                        <i
                                          className="fa fa-trash-o"
                                          style={{
                                            paddingLeft: 10,
                                            fontSize: 14,
                                            color: config.themeColor,
                                            cursor: "pointer",
                                          }}
                                          data-toggle="modal"
                                          title="Delete floating crane charges"
                                          data-placement="bottom"
                                          data-keyboard="false"
                                          data-target="#deleteConformationModal"
                                          data-backdrop="static"
                                          onClick={() =>
                                            this.deleteCharges(idr)
                                          }
                                        ></i>
                                      )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        )}
                      {this.props.demurrageType === "both" &&
                        this.state.buyerData.length > 0 && (
                          <tbody>
                            {this.state.buyerData.map((idr, indx) => (
                                <tr key={indx}>
                                  {this.state.features.includes("50") ||
                                    this.state.features.includes("97") ? (
                                    <td>
                                      <i
                                        aria-hidden="true"
                                        style={{
                                          fontStyle: "normal",
                                          color: config.themeColor,
                                          cursor: "pointer",
                                          whiteSpace: "nowrap",
                                        }}
                                        onClick={() =>
                                          this.setState({
                                            openDrawer: true,
                                            MvBuyerDemurrageAdd: false,
                                            MvBuyerDemurrageView: true,
                                            MvBuyerDemurrageUpdate: false,
                                            businessNo: idr.business_no_id,
                                            MvBuyerDemurrageID: idr.id,
                                          })
                                        }
                                      >
                                        {idr.costing_no}
                                      </i>
                                    </td>
                                  ) : (
                                    <td nowrap="true">{idr.costing_no}</td>
                                  )}
                                  <td nowrap="true">{idr.buyer_name}</td>
                                  <td
                                    className="allocation_table_value text-right"
                                    nowrap="true"
                                  >
                                    {toLocaleString(idr.demurrage_per_day)}
                                    {idr.billing_currency}
                                  </td>
                                  <td
                                    className="allocation_table_value text-right"
                                    nowrap="true"
                                  >
                                    {toLocaleString(idr.despatch_per_day)}
                                  </td>
                                  <td nowrap="true">
                                    {idr.demurrage_or_despatch}
                                  </td>
                                  {idr.demurrage_or_despatch === "Demurrage" ? (
                                    <td
                                      className="allocation_table_value text-right"
                                      nowrap="true"
                                    >
                                      {toLocaleString(idr.demurrage_incurred)}
                                    </td>
                                  ) : (
                                    <td
                                      className="allocation_table_value text-right"
                                      nowrap="true"
                                    >
                                      {toLocaleString(idr.despatch_incurred)}
                                    </td>
                                  )}
                                  <td
                                    className="allocation_table_value text-right"
                                    nowrap="true"
                                  >
                                    {toLocaleString(idr.buyer_ctc)}
                                    {config.company === "SRPL" ||
                                      config.company === "AVS" ||
                                      config.company === "PRPL"
                                      ? "USD"
                                      : "IDR"}
                                  </td>
                                  <td
                                    nowrap="true"
                                    className="table_td text-left pl-4"
                                  >
                                    {(this.state.features.includes("51") ||
                                      this.state.features.includes("97")) && (
                                        <i
                                          className="fa fa-pencil"
                                          style={{
                                            fontSize: 14,
                                            color: config.themeColor,
                                            cursor: "pointer",
                                          }}
                                          data-toggle="modal"
                                          title="Edit floating crane charges"
                                          data-placement="bottom"
                                          onClick={() =>
                                            this.setState({
                                              businessNo: idr.business_no_id,
                                              MvBuyerDemurrageID: idr.id,
                                              openDrawer: true,
                                              MvBuyerDemurrageUpdate: true,
                                            })
                                          }
                                        ></i>
                                      )}
                                    {idr.payment_postings_availability === 0 &&
                                      (this.state.features.includes("388") ||
                                        this.state.features.includes("97")) && (
                                        <i
                                          className="fa fa-trash-o"
                                          style={{
                                            paddingLeft: 10,
                                            fontSize: 14,
                                            color: config.themeColor,
                                            cursor: "pointer",
                                          }}
                                          data-toggle="modal"
                                          title="Delete floating crane charges"
                                          data-placement="bottom"
                                          data-keyboard="false"
                                          data-target="#deleteConformationModal"
                                          data-backdrop="static"
                                          onClick={() =>
                                            this.deleteCharges(idr)
                                          }
                                        ></i>
                                      )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
